import sensedia from "./sensedia";
import sensediaCorp from "./sensediaCorp";
import portal from "./portal";
import portalAws from "./portalAws";
import httpClient from "./http-client";
import bff from "./bff";
import bffPub from "./bff-pub";

export { sensedia, sensediaCorp, portal, portalAws, httpClient, bff, bffPub };



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/index.js